/**
 * Created by Administrador on 24/04/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('economicActivityService',economicActivityService);

    economicActivityService.$inject = ['$http', 'CONFIG','messageService'];

    function economicActivityService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FINANCE + '/' + CONFIG.API + '/economicActivities';

        var service = {
            getEconomicActivities: getEconomicActivities,
            getPageEconomicActivities: getPageEconomicActivities,
            getEconomicActivity: getEconomicActivity,
            getEconomicActvitiesByTaxpayer: getEconomicActvitiesByTaxpayer,
            getEconomicActvitiesNotStateWaitingByTaxpayer: getEconomicActvitiesNotStateWaitingByTaxpayer,
            saveEconomicActivity: saveEconomicActivity,
            updateEconomicActivity: updateEconomicActivity,
            deleteEconomicActivity: deleteEconomicActivity,
            getEconomicActivitiesByTaxpayer: getEconomicActivitiesByTaxpayer
        };

        return service;

        function getEconomicActivities(detailed){
            return $http.get(urlBase + "?detailed="+detailed)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.economicActivities : [];
                }, function(){
                    messageService.findAllError('');
                });
        }

        function getPageEconomicActivities(page, size, detailed){
            return $http.get(urlBase + "/" + 'page?detailed='+detailed+'&page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getEconomicActivity(id){
            return $http.get(urlBase + "/" + id)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findAllError('economicActivities');
                });
        }

        function getEconomicActvitiesByTaxpayer(id){
            return $http.get(urlBase + "/" + id + "/byTaxpayer")
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.economicActivities : [];
                }, function(){
                    messageService.findAllError('economicActivities');
                });
        }

        function getEconomicActvitiesNotStateWaitingByTaxpayer(id){
            return $http.get(urlBase + "/" + id + "/byTaxpayerAndNotStateWaiting")
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.economicActivities : [];
                }, function(){
                    messageService.findAllError('economicActivities');
                });
        }

        function saveEconomicActivity(economicActivity){
            return $http.post(urlBase, economicActivity)
                .then(function(){
                    messageService.register('economicActivities');
                }, function(){
                    messageService.registerError('economicActivities');
                });
        }

        function updateEconomicActivity(economicActivity, id){
            return $http.put(urlBase + "/" + id, economicActivity)
                .then(function(){
                    messageService.registerUpdate('economicActivities');
                }, function(){
                    messageService.registerUpdateError('economicActivities');
                });
        }

        function deleteEconomicActivity(id){
            return $http.delete(urlBase + "/" + id)
                .then(function(){
                    messageService.registerDelete('economicActivities');
                }, function(error){
                    if(error.data.message.indexOf('asociación')> -1 || error.data.message.indexOf('asociacion') > -1
                        || error.data.message.indexOf('association') > -1 || error.data.message.indexOf('associated') > -1){
                        messageService.registerDeleteGeneralError('economicActivities','air.economicActivity.associatedDosages');
                    }else{
                        messageService.registerDeleteError('economicActivities');
                    }
                })
        }

        function getEconomicActivitiesByTaxpayer(taxpayerId){
            return $http.get(urlBase + '/' + taxpayerId + "/byTaxpayer")
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.economicActivities : [];
                }, function(){
                    messageService.findAllError('');
                });
        }
    }
})();
